import React, { useEffect, useState } from "react";
import { SortArrow } from "../../svg/sort-arrow";
import CustomCheckBox from "../customCheckBox/customCheckBox";
import { TableCellType } from "./table";

/** Props for the sortable custom-table column header row. */
interface TableHeaderProps {
  sortedTableHeaders: {
    key: string;
    label: string;
    width: number;
    sortable: boolean;
    subKey?: string;
    type?: string;
    /** When true on a CHECKBOX column, omits the header select-all control. */
    hideHeaderCheckbox?: boolean;
  }[];
  tableWidth: number;
  onSortTableData: (key: string, subKey?: string, type?: string) => void;
  onSelectAll?: () => void;
  isCheckboxSelected?: boolean;
}

/**
 * Renders the custom-table header row with optional sort arrows and select-all checkbox.
 *
 * @param props - Header configuration and sort/select callbacks
 * @returns Table header element
 */
const TableHeader: React.FC<TableHeaderProps> = ({
  sortedTableHeaders,
  tableWidth,
  onSortTableData,
  onSelectAll,
  isCheckboxSelected,
}) => {
  const [isChecked, setIsChecked] = useState(false);

  useEffect(() => {
    setIsChecked(isCheckboxSelected || false);
  }, [isCheckboxSelected]);

  return (
    <thead>
      <tr style={{ display: "flex", width: "100%" }}>
        {sortedTableHeaders.map((header, index) => {
          const isSelectAll =
            header.type === TableCellType.CHECKBOX &&
            !header.hideHeaderCheckbox;

          return (
            <td
              key={index}
              style={{
                width: `${header.width}%`,
              }}
            >
              <div
                className="header-details"
                onClick={isSelectAll ? onSelectAll : undefined}
              >
                {/* `truncate` sets overflow:hidden, which lets this flex item shrink
                    below the checkbox width and clip it; checkbox headers opt out. */}
                <div
                  className={`header-details--text ${
                    isSelectAll ? "shrink-0" : "truncate"
                  }`}
                >
                  {isSelectAll ? (
                    <div className="header-details--checkbox flex items-center justify-center">
                      <CustomCheckBox
                        id={header.key}
                        label={""}
                        isChecked={isChecked}
                        onCheckBoxValueChange={() => setIsChecked(!isChecked)}
                        removeGap={true}
                      />
                    </div>
                  ) : (
                    header.label
                  )}
                </div>
                <div className="header-details--icon">
                  {header.sortable && (
                    <SortArrow
                      onClick={() =>
                        onSortTableData(header.key, header.subKey, header.type)
                      }
                    />
                  )}
                </div>
              </div>
            </td>
          );
        })}
      </tr>
    </thead>
  );
};

export default TableHeader;
